import * as React from 'react';
import { Modal, Button } from '@grandvisionhq/common';

const InfoModal = ({ isOpen , onModalClose , title , message , okLabel  })=>{
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isOpen,
        onModalClose: onModalClose,
        title: title,
        showIcon: true,
        footer: /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Button, {
            caption: okLabel,
            onClick: onModalClose
        }))
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            margin: '1rem 0'
        }
    }, message));
};
var InfoModal$1 = InfoModal;

export { InfoModal, InfoModal$1 as default };
//# sourceMappingURL=InfoModal.js.map
